import React from 'react';

import styled from 'styled-components';

import Checkbox from '../../lib/Checkbox';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  border-top: 1px solid var(--line-gray);
  padding: 10px 20px;
`;

const Title = styled.span`
  font-family: var(--font-bold);
  margin-bottom: 15px;
`;

const ItemsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const Item = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
`;

type Props = {
  dataTestId?: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  title?: string;
};

const SelectAdvancedFilterCheckboxOptions = ({ checked, dataTestId, onChange, title }: Props) => {
  return (
    <Container>
      {title && <Title>{title}</Title>}
      <ItemsList>
        <Item onClick={() => onChange(!checked)} data-test-id={dataTestId}>
          <Checkbox checked={checked} className={'green'} />
          <span>No Propagation</span>
        </Item>
      </ItemsList>
    </Container>
  );
};

export default SelectAdvancedFilterCheckboxOptions;
